"use client";

import { Button as ButtonPrimitive } from "@base-ui/react/button";
import * as React from "react";

import type { ButtonVariantProps } from "@/components/ui/button-variants";
import { buttonVariants } from "@/components/ui/button-variants";
import { updateLightLeakPosition } from "@/lib/button-light-leak";
import { cn } from "@/lib/utils";

export interface ButtonProps extends ButtonPrimitive.Props, ButtonVariantProps {
  gradientSurface?: "light" | "dark";
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      children,
      gradientSurface,
      variant,
      size,
      render,
      nativeButton,
      onPointerEnter,
      onPointerMove,
      ...props
    },
    ref
  ) => {
    const tracksLightLeak = variant === "secondary-gradient-hover";

    return (
      <ButtonPrimitive
        ref={ref}
        data-slot="button"
        data-gradient-surface={
          tracksLightLeak && gradientSurface === "dark" ? "dark" : undefined
        }
        className={cn(buttonVariants({ variant, size }), className)}
        nativeButton={nativeButton ?? !render}
        render={render}
        onPointerEnter={
          tracksLightLeak
            ? (event) => {
                updateLightLeakPosition(event.currentTarget, event.clientX);
                onPointerEnter?.(event);
              }
            : onPointerEnter
        }
        onPointerMove={
          tracksLightLeak
            ? (event) => {
                updateLightLeakPosition(event.currentTarget, event.clientX);
                onPointerMove?.(event);
              }
            : onPointerMove
        }
        {...props}
      >
        {tracksLightLeak ? (
          <span data-slot="button-gradient-label">{children}</span>
        ) : (
          children
        )}
      </ButtonPrimitive>
    );
  }
);
Button.displayName = "Button";

export { Button };
